const SCROLL_BEHAVIOUR: ScrollIntoViewOptions = { behavior: 'smooth', block: 'center' };

/**
 * Defines the anchor targets
 */
export enum AnchorTarget {
    SIZE_SELECTION = "size-selection"
}

/**
 * Use spread operator like <div {...anchor(AnchorTarget.SIZE_SELECTION)} >
 * to introduce an anchor to an element
 * @param target the type of the anchor target
 */
export function anchorProps(target: AnchorTarget) {
    return {id: target};
}

/**
 * Scrolls to the desired anchor target
 * @param target the target to scroll to
 */
export function scrollTo(target: AnchorTarget) {
    document.querySelector(`#${target}`)?.scrollIntoView(SCROLL_BEHAVIOUR);
}